import type { Content } from "@/app/queries";
import { BLOCK_DEFS, type Patch } from "./shared";
import { QuizEditor } from "./QuizEditor";
import { StuckEditor } from "./StuckEditor";

/** Блоки шага: «проверь себя» (вопрос–ответ), «типичные ошибки», «пример кода»,
 *  «заметки менторов» и «Если застрял». */
export function BlocksTab({ content, patch }: { content: Content; patch: (p: Patch) => void }) {
  return (
    <div className="flex flex-col gap-3">
      {BLOCK_DEFS.map((b) => {
        const block = content.blocks[b.id] ?? { on: false, text: "" };
        const set = (next: Partial<Content["blocks"][string]>) => patch((c) => ({ ...c, blocks: { ...c.blocks, [b.id]: { ...(c.blocks[b.id] ?? { on: false, text: "" }), ...next } } }));
        return (
          <section key={b.id} className="overflow-hidden rounded-md border border-bd bg-card" style={{ borderLeft: `2px solid ${b.accent}` }} data-testid={`block-${b.id}`}>
            <div className="flex items-center gap-2.5 border-b border-bd px-3.5 py-[11px]">
              {/* Акцент кода — --bd2 — это цвет рамки; для 11px текста не проходит 4.5:1 (CLAUDE.md «Контраст»). */}
              <span className="font-mono text-[11px] tracking-[.05em]" style={{ color: b.accent === "var(--bd2)" ? "var(--ink2)" : b.accent }}>
                {b.tag}
              </span>
              <span className="text-[13.5px] font-semibold">{b.title}</span>
              <span className="flex-1" />
              <label className="flex cursor-pointer items-center gap-[7px]">
                <input type="checkbox" checked={block.on} onChange={(e) => set({ on: e.target.checked })} className="size-[15px] cursor-pointer accent-[var(--acc)]" />
                <span className="font-mono text-[11px]" style={{ color: block.on ? "var(--acc)" : "var(--mut)" }}>
                  {block.on ? "показывать" : "скрыт"}
                </span>
              </label>
            </div>
            <div className="px-3.5 py-3">
              {b.id === "quiz" ? (
                <QuizEditor block={block} patch={patch} />
              ) : (
                <textarea
                  aria-label={b.title}
                  rows={4}
                  value={block.text}
                  onChange={(e) => set({ text: e.target.value })}
                  className={`block w-full resize-y rounded-sm border border-bd2 bg-bg2 px-[11px] py-2.5 text-[12.5px] leading-[1.6] text-ink outline-none focus:border-acc ${b.mono ? "font-mono" : "font-sans"}`}
                />
              )}
              <div className="mt-2 font-mono text-[10.5px] text-mut">{b.hint}</div>
            </div>
          </section>
        );
      })}
      <StuckEditor content={content} patch={patch} />
    </div>
  );
}
